import { Routes, Route, Navigate } from 'react-router-dom';

import { DashboardLayout } from '@/layouts/DashboardLayout';

import LoginPage from './app/login/page';
import OnboardingPage from './app/onboarding/page';

import DashboardHome from './app/(dashboard)/page';
import ProjectsPage from './app/(dashboard)/projects/page';
import ProjectPage from './app/(dashboard)/projects/[id]/page';
import ProjectExecutionsPage from './app/(dashboard)/projects/[id]/executions/page';
import ExecutionInspectorPage from './app/(dashboard)/projects/[id]/executions/[eid]/page';
import ProjectTestsPage from './app/(dashboard)/projects/[id]/tests/page';
import ExplorerPage from './app/(dashboard)/explorer/page';
import ProfilePage from './app/(dashboard)/profile/page';
import TeamPage from './app/(dashboard)/team/page';
import UsagePage from './app/(dashboard)/usage/page';
import SubscriptionPage from './app/(dashboard)/subscription/page';

export function AppRouter(): import('react/jsx-runtime').JSX.Element {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/onboarding" element={<OnboardingPage />} />

      {/* Authenticated dashboard routes */}
      <Route element={<DashboardLayout />}>
        <Route index element={<DashboardHome />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:id" element={<ProjectPage />} />
        <Route path="/projects/:id/executions" element={<ProjectExecutionsPage />} />
        <Route path="/projects/:id/executions/:eid" element={<ExecutionInspectorPage />} />
        <Route path="/projects/:id/tests" element={<ProjectTestsPage />} />
        <Route path="/explorer" element={<ExplorerPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/settings" element={<Navigate to="/profile" replace />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/usage" element={<UsagePage />} />
        <Route path="/subscription" element={<SubscriptionPage />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
